import React from "react";
import { motion } from "framer-motion";
import { IoLocationSharp, IoMail, IoCall } from "react-icons/io5";

const fadeVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeInOut" },
  },
};

const ContactUsSection = () => {
  return (
    <section id="contact-us">
      <motion.div
        id="contact-contact"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
        variants={fadeVariant}
      >
        <h2 className="text-center pb-3">
          <strong id="ContactUs">Contact Us</strong>
        </h2>
        <div className="row">
          <div style={{ marginBottom: 15 }} className="col-md-6">
            <div className="container-fluid">
              <div className="row">
                <div id="info" className="col-md text-center">
                  <div className="d-inline-block">
                    <h2><IoLocationSharp className="icon" /></h2>
                    <h3><strong>Address</strong></h3>
                    <p>
                      Jl. Prof. Dr. Sumantri Brojonegoro No. 1 Bandar Lampung,
                      Lampung 35145, Indonesia.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div id="info" className="col-md text-center">
                  <div className="d-inline-block">
                    <h2><IoMail className="icon" /></h2>
                    <h3><strong>Email</strong></h3>
                    <p>ardian.ulvan@eng.unila.ac.id</p>
                  </div>
                </div>
                <div id="info" className="col-md text-center">
                  <div className="d-inline-block">
                    <h2><IoCall className="icon" /></h2>
                    <h3><strong>Call</strong></h3>
                    <p>+62 853 8185 5404</p>
                  </div>
                </div>
                <div style={{ paddingBottom: 5 }} />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <form action="#">
              <div className="input-box">
                <div className="row">
                  <div id="name" className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your Name"
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Your Email"
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Subject"
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <textarea
                    style={{ height: 200 }}
                    className="form-control"
                    rows={3}
                    placeholder="Message"
                  />
                </div>
              </div>
              <div className="text-center">
                <button
                  style={{ marginBottom: 20 }}
                  className="btn btn-danger"
                  type="button"
                >
                  <a
                    href="mailto:chairunisaap1@gmail.com"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Send Message
                  </a>
                </button>
              </div>
            </form>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default ContactUsSection;
